import React from "react";

export interface GridFeature {
  id: number;
  title: string;
  icon: string;
  bgImage: string;
  layout: "image-below" | "image-above";
}

interface FeatureSectionGridProps {
  features: GridFeature[];
  className?: string;
}

const FeatureCard: React.FC<GridFeature> = ({ title, icon, bgImage, layout }) => {
  if (layout === "image-below") {
    return (
      <div className="relative h-full min-h-[420px] rounded-[32px] overflow-hidden bg-gray-100 group">
        {/* Content */}
        <div className="relative p-8">
          {/* Icon */}
          <div className="mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <img loading="lazy" src={icon} alt="" className="w-full h-full object-contain" />
            </div>
          </div>

          {/* Title */}
          <h3 className="text-2xl font-normal">{title}</h3>
        </div>

        {/* Background Image Below with spacing */}
        <div className="relative -mt-10">
          <img loading="lazy" src={bgImage} alt="" className="w-full object-contain" />
        </div>
      </div>
    );
  }

  return (
    <div className="relative h-full min-h-[420px] rounded-[32px] overflow-hidden bg-gray-100 group">
      {/* Background Image on Top */}
      <div className="relative">
        <img loading="lazy" src={bgImage} alt="" className="w-full object-contain" />
      </div>

      {/* Content */}
      <div className="relative p-8">
        {/* Icon */}
        <div className="mb-4">
          <div className="w-6 h-6 flex items-center justify-center">
            <img loading="lazy" src={icon} alt="" className="w-full h-full object-contain" />
          </div>
        </div>

        {/* Title */}
        <h3 className="text-2xl font-normal">{title}</h3>
      </div>
    </div>
  );
};

const FeatureSectionGrid: React.FC<FeatureSectionGridProps> = ({ features, className = "" }) => {
  return (
    <section className={`relative py-16 ${className}`}>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature) => (
            <div key={feature.id}>
              <FeatureCard {...feature} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSectionGrid;
